import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { ErrorPage } from './pages/ErrorPage';
import { FormPage } from './pages/FormPage';
import { SuccessPage } from './pages/SuccessPage';
import { LeadFormProviders } from './resources/LeadFormProviders';

const LeadFormInit = () => {
  return (
    <LeadFormProviders>
      <Switch>
        <Route path={['/lead-form/:orgName/:token']}>
          <FormPage />
        </Route>
        <Route path={['/success/lead-form/:orgName/:token']}>
          <SuccessPage />
        </Route>
        <Route path="*">
          <ErrorPage />
        </Route>
      </Switch>
    </LeadFormProviders>
  );
};

export default LeadFormInit;
